import api from '@/api';
import { API_BASE_URL } from '..';
import {
  ReportTemplatesReceiptRequest,
  ReportTemplatesWorkorderRequest,
} from './ReportTemplates.types';

const CONTROLER = `${API_BASE_URL}/generate/template`;

const reportTemplatesServices = {
  async generateWorkorder(params: ReportTemplatesWorkorderRequest) {
    const result = (await api.getReport(`${CONTROLER}/workOrder`, params, {
      responseEncoding: 'binary',
      headers: {
        'Content-type': 'application/pdf',
      },
    })) as unknown;

    return result as ArrayBuffer;
  },

  async generateReceipt(params: ReportTemplatesReceiptRequest) {
    const result = (await api.getReport(
      `${CONTROLER}/receipt-template`,
      params,
    )) as unknown;

    return result as BlobPart;
  },
};

export default reportTemplatesServices;
